import { render, staticRenderFns } from "./DadosAnaliseSolicitacao.vue?vue&type=template&id=6965e5a2&"
import script from "./DadosAnaliseSolicitacao.vue?vue&type=script&lang=ts&"
export * from "./DadosAnaliseSolicitacao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCardTitle,VTextarea})
